module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['monitor', {
      'active': _vm.show
    }]
  }, [_c('div', {
    staticClass: "grid-content bg-purple grid-left-ico box animated"
  }, [_c('img', {
    staticClass: "gt",
    attrs: {
      "src": require("../static/1.png"),
      "height": "48",
      "width": "48"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "grid-content-a1"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('a', {
    staticClass: "grid-content-a2",
    attrs: {
      "href": _vm.url
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/2.png"),
      "height": "40",
      "width": "40"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c13c03d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/browser/src/BrowserCheck.vue
// module id = 1233
// module chunks = 2